import React from 'react'
import { ChevronUp, ChevronDown, ChevronsUpDown } from 'lucide-react'

const ColumnSort = ({ 
  column, 
  currentSort, 
  onSortChange,
  className = ""
}) => {
  const getSortState = () => {
    if (!currentSort || currentSort.column !== column) {
      return 'none'
    }
    return currentSort.order
  }

  const handleSortClick = () => {
    const currentState = getSortState()
    let newOrder
    
    if (currentState === 'none') {
      newOrder = 'asc'
    } else if (currentState === 'asc') {
      newOrder = 'desc'
    } else {
      // desc -> none (remove sort)
      newOrder = null
    }

    onSortChange(newOrder ? { column, order: newOrder } : null)
  }

  const sortState = getSortState()

  return (
    <button
      onClick={handleSortClick}
      className={`flex items-center justify-center p-1 rounded hover:bg-gray-100 transition-colors ${className}`}
      title={`Sort by ${column} ${
        sortState === 'none' ? '(click to sort ascending)' :
        sortState === 'asc' ? '(click to sort descending)' :
        '(click to remove sort)'
      }`}
    >
      {sortState === 'asc' ? (
        <ChevronUp className="h-4 w-4 text-primary-600" />
      ) : sortState === 'desc' ? (
        <ChevronDown className="h-4 w-4 text-primary-600" />
      ) : (
        <ChevronsUpDown className="h-4 w-4 text-gray-400 hover:text-gray-600" />
      )}
    </button>
  )
}

export default ColumnSort
